// web/src/components/waveform.ts — UI-10 traffic-light waveform.
//
// Binds to a real AnalyserNode (NOT a timer). rAF-driven. Theme-color
// tint applied when peak exceeds 0.05 — the "traffic-light" UX cue.
// Reduced-motion: caller halves the rAF rate (skip every other frame).

export interface WaveformHandle { stop: () => void; }

export function startWaveform(
  canvas: HTMLCanvasElement,
  analyser: AnalyserNode,
  themeColor: string,
): WaveformHandle {
  const rawCtx = canvas.getContext("2d");
  if (!rawCtx) throw new Error("waveform: 2d context unavailable");
  // Capture as a non-null reference so the closure below narrows correctly.
  const ctx: CanvasRenderingContext2D = rawCtx;
  const buf = new Uint8Array(analyser.fftSize);
  let stopped = false;

  function draw() {
    if (stopped) return;
    requestAnimationFrame(draw);
    analyser.getByteTimeDomainData(buf);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    const sliceW = canvas.width / buf.length;
    let x = 0;
    let peak = 0;
    for (let i = 0; i < buf.length; i++) {
      const v = buf[i]! / 128.0;
      const y = (v * canvas.height) / 2;
      if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      const dev = Math.abs(v - 1);
      if (dev > peak) peak = dev;
      x += sliceW;
    }
    ctx.strokeStyle = peak > 0.05 ? themeColor : "#1A1A1A";
    ctx.lineWidth = 2;
    ctx.stroke();
  }
  draw();
  return { stop: () => { stopped = true; } };
}
